import { createApp, InjectionKey, Ref, ref } from "vue";
import App from "./App.vue";
import router from "./router/index";
import './generalStyle/commons/root.scss'

createApp(App).use(router).mount("#app");
